
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#112A46","stroke-width":"1.5","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M7.667 1.333h.181c2.175 0 3.262 0 4.017.532.216.153.408.333.57.537.565.71.565 1.734.565 3.78v1.697c0 1.975 0 2.963-.313 3.752-.502 1.268-1.565 2.268-2.913 2.741-.838.295-1.887.295-3.986.295-1.2 0-1.8 0-2.278-.168a2.755 2.755 0 01-1.665-1.567c-.178-.45-.178-1.015-.178-2.144V8","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13 8a2.222 2.222 0 01-2.222 2.222c-.444 0-.967-.078-1.399.038a1.111 1.111 0 00-.786.786c-.115.431-.037.955-.037 1.398a2.222 2.222 0 01-2.223 2.223","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.333 4H1m2.667-2.667v5.334"}})])])
          )
        }
      }
    